export enum NewIssueLoadingState {
    loadingIssue = 'Loading Page',
    submitting = 'Submitting Issue',
    uploadingFiles = 'Uploading Files'
}